export const notifications = {
    state: {
        notifications: []
    },
    mutations: {
        ADD_NOTIFICATION(state, notification) {
            state.notifications.push(notification)
        },
        REMOVE_NOTIFICATION(state, id) {
            const i = state.notifications.map(item => item.id).indexOf(id)
            if(i > -1) {
                state.notifications.splice(i, 1)
            }
        }
    },
    actions: {
        addNotification({ state, commit, dispatch }, notification) {
            const limit = Object.prototype.hasOwnProperty.call(notification, 'limit') ? notification.limit : 2
            // remove first if too much
            if(state.notifications.length > limit) {
                state.notifications.shift()
            }
            // timestamp for ID
            notification.id = Date.now()
            commit('ADD_NOTIFICATION', notification)
            setTimeout(() => {
                if(!notification.dontRemove) {
                    dispatch('removeNotification', notification.id)
                }
            }, 4000)
        },
        removeNotification({ commit }, notification) {
            commit('REMOVE_NOTIFICATION', notification)
        }
    },
    getters: {
        notifications: (state) => {
            if(state.notifications) {
                return state.notifications
            }
        }
    }
}
